import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  EventEmitter,
} from '@angular/core';
import { UserWO } from 'src/app/models/administration/user-WO';
import { DataResouce } from 'src/app/models/commos/base-response-data';
import { SizePicture } from 'src/app/models/commos/size-pircture';
import { CommentDto } from 'src/app/models/maintenance/comment';
import { HistoricalWO } from 'src/app/models/maintenance/historicalWO';
import { Resources } from 'src/app/models/maintenance/resources';
import { WorkOrder } from 'src/app/models/maintenance/work-order';
import { CommentService } from 'src/app/services/comment.service';
import { DeleteGenericService } from 'src/app/services/delete-generic.service';
import { UploadService } from 'src/app/services/upload.service';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import {
  FunctionsService,
  HttpService,
  LocalStorageService,
  MessageService,
  ScreenSizeUtil,
  TableColumns,
  TableConfiguration,
  enumActions,
  params,
} from 'brainloper-ui';

@Component({
    selector: 'app-work-order-summary',
    templateUrl: './work-order-summary.component.html',
    styleUrls: ['./work-order-summary.component.scss'],
    standalone: false
})
export class WorkOrderSummaryComponent implements OnInit, OnChanges {
  @Input() workOrderDetails = new HistoricalWO();
  public EndpointDictionary = EndpointDictionary;

  private urlHistoryDetails: string = `${EndpointDictionary.historicalWO.CRUD_HISTORICAL_WO_DATA}`;
  private urlWorkOrderDatails: string = `${EndpointDictionary.WorkOrder.CRUD_WORK_ORDER_DATA}`;
  public urlGetTableResources: string = `${EndpointDictionary.Resources.RESOURCES_TABLE}`;
  private urlGetUserOrder: string = `${EndpointDictionary.UserOrder.USER_ORDER_TABLE}`;

  public userId:number
  public companyId:number
  public inventoryModule: boolean
  public totalCostItems: number = 0;
  public imageSrc: string;
  public imageSrc2: string;
  public imageSrc3: string;
  public sizePicture: SizePicture;

  public resources: Array<Resources> = [{ itemName: '' }];
  public data = new HistoricalWO();
  public bodyUsuarios: UserWO[] = [];
  public viewAnexos: boolean = true;

  // Resources Table
  public paramsResources: params[] = [{ id: 'orderId', value: '0' }];

  public configurationResouces: TableConfiguration = {
    primaryKey: 'id',
  };
  public columnsResouces: TableColumns<any>[] = [
    {
      ID: 'code',
      label: 'Código Item',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'itemName',
      label: 'Nombre',
      type: 'combo',
      disregardForEdit: true,
      style: {
        textAlign: 'center',
      },
      paramsCombo: {
        selectionField: 'id',
        visibleField: 'name',
        urlParams: [],
        url: `${EndpointDictionary.Item.ITEM_COMBO}`,
      },
    },
    {
      ID: 'amount',
      label: 'Cantidad',
      type: 'number',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'costItem',
      label: 'Costo Item',
      type: 'thousandSeparator',
      style: {
        textAlign: 'center',        
        movil: 'no-movil',
      },
    },
    {
      ID: 'totalCostItems',
      label: 'Costo Total Item',
      type: 'thousandSeparator',
      style: {
        textAlign: 'center',
      },
    },
  ];


  isMobile:boolean
  //comment table
  public titleC: string = screen.width > 400 ? 'Comentarios OT' : ''
  public paramsComments: params[] = [{ id: 'orderId', value: '0' }];
  public reloadComments = new EventEmitter<any>();
  public configurationComments: TableConfiguration = {   
    primaryKey: 'id',
  };

  public columnsComments: TableColumns<CommentDto>[] = [
    {
      ID: 'comment',
      label: 'Comentario',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'attachmentUrl',
      label: 'Archivo Adjunto',
      type: 'text',
      style: {
        textAlign: 'center',
      },
      rules: [
        {
          action: enumActions.SHOW_FILE_ICON,
        },
      ],
    },
    {
      ID: 'createdBy',
      label: 'Creado por',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
  ];

  constructor(
    private storage: LocalStorageService,
    private http: HttpService,
    private functionEter: FunctionsService,
    private uploadService: UploadService,
    public deleteItem: DeleteGenericService,
    private commentService: CommentService,
    private message: MessageService
  ) {
    this.isMobile = ScreenSizeUtil.isMobile();
    this.userId = this.storage.get<number>('cedula');
    this.companyId = this.storage.get<number>('companyId');
    this.inventoryModule = this.storage.get<boolean>('inventory_module');
  }

  ngOnInit(): void {
    this.picture();
  }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes['workOrderDetails']?.currentValue) {
      await this.initializeDetailsValues();
    }
  }

  picture() {
    this.sizePicture = {
      width: '100%',
      height: screen.width > 400 ? '240px' : '150px',
      margin: '3px',
      visibility: 'hidde',
    };
  }

  async dataResources($event: DataResouce<Array<Resources>>) {
    this.resources = $event.data;
    this.totalCostItems = $event.totalCostItems;
  }

  async initializeDetailsValues() {
    let paramsUserOrder: params[] = [
      { id: 'page', value: '0' },
      { id: 'per_page', value: '12' },
      { id: 'filter', value: '' },
      { id: 'orderId', value: this.workOrderDetails.workOrderId || this.workOrderDetails.id},
    ];
    let indexA = this.paramsResources.findIndex((x) => x.id == 'orderId');
    this.paramsResources[indexA].value = this.workOrderDetails.workOrderId || this.workOrderDetails.id;
    this.paramsComments = [
      { id: 'orderId', value: this.workOrderDetails.workOrderId || this.workOrderDetails.id },
    ];
    let res: Array<HistoricalWO> | Array<WorkOrder> = [];
    if (this.workOrderDetails.id > 0 && this.workOrderDetails.workOrderId) {
      res = await this.http.getDataBody<Array<HistoricalWO>>(
        `${this.urlHistoryDetails}/${this.workOrderDetails.id}`
      );
    } else {
      res = await this.http.getDataBody<Array<WorkOrder>>(
        `${this.urlWorkOrderDatails}/${this.workOrderDetails.workOrderId || this.workOrderDetails.id}`
      );
    }
    if (res) {     
      this.data = res[0];      
      this.imageSrc = this.uploadService.getImagen(
        this.data.photo1,
        this.companyId
      );
      this.imageSrc2 = this.uploadService.getImagen(
        this.data.photo2,
        this.companyId
      );
      this.imageSrc3 = this.uploadService.getImagen(
        this.data.photo3,
        this.companyId
      );
      this.data.executionDate = this.functionEter.dateIso(res[0].executionDate);
      let resUser: Array<UserWO> = await this.http.getDataBody(
        `${this.urlGetUserOrder}`,
        paramsUserOrder
      );
      if (resUser) {
        this.bodyUsuarios = resUser['data'];
      } else {
        this.bodyUsuarios = [
          { name: 'No se tiene asociada informacion' },
          { responsibleType: '' },
        ];
      }
    }
  }

  async deleteComments($event: Array<CommentDto>) {
    await this.deleteItem.deleteD(
      $event,
      EndpointDictionary.WorkOrder.COMMENTS.CRUD_DATA,
      'id',
      'Comentario',
      'Comentarios'
    );
    this.reloadComments.emit();
  }

  async addComments($event: number) {
    this.commentService.addComment(this.workOrderDetails.workOrderId || this.workOrderDetails.id, () => {
      this.reloadComments.emit();
    });
  }

  async editComments($event: CommentDto) {
    if ($event[0].createdById != this.userId) {
      this.message.Error(
        'Acción no permitida',
        'Solo puedes editar los comentarios que has creado.'
      );
      return;
    }
    await this.commentService.editComment($event[0], () => {
      this.reloadComments.emit();
    });
  }

  onFileIconClick($event: string) {
    this.commentService.showAttachment($event, this.companyId);
  }
}
